.cover {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: var(--radius-full);
}

.positive svg {
  color: var(--sentiment-positive);
}

.negative svg {
  color: var(--sentiment_error);
}

.very_positive svg {
  color: var(--sentiment-very-positive);
}

.very_negative svg {
  color: var(--sentiment_very_error);
}

.listItem {
  position: relative;
}

.listItem:not(:last-child) {
  margin-bottom: 1rem;
}

/* Not `useColumns`: React Compiler reads a `use*`-named property as a hook
   reference and skips the whole component. */
.multiColumn {
  @media (--sm-up) {
    column-count: 2;
  }

  @media (--md-up) {
    column-count: 3;
  }
}

.channelColumn {
  display: flex;
  gap: 0.75rem;
  padding-left: 5.5rem;
  cursor: pointer;
}

.count {
  font-size: 0.85rem;
}

.clickableRow {
  cursor: pointer;
}
